import { motion } from "framer-motion";
import { ArrowRight, Lightbulb, Box, Signpost, PanelTop, Blinds, Car, Printer, Store } from "lucide-react";

const WHATSAPP_LINK = "https://wa.me/33643693688?text=Bonjour%2C%20je%20souhaite%20un%20devis%20pour%20une%20enseigne.";

const services = [
  { icon: Lightbulb, title: "Enseignes Lumineuses LED", desc: "Enseignes à LED haute performance, lettres rétro-éclairées, enseignes néon LED. Faible consommation, forte visibilité jour et nuit." },
  { icon: Box, title: "Caissons Lumineux", desc: "Caissons simple et double face, impression HD, éclairage LED intégré. Idéal pour une visibilité maximale en façade ou en drapeau." },
  { icon: PanelTop, title: "Lettres Relief & Boîtier", desc: "Lettres découpées PVC, aluminium ou inox. Lettres boîtier lumineuses. Finition premium, fixation entretoises ou face avant." },
  { icon: Signpost, title: "Totems & Pylônes", desc: "Totems lumineux autoportants, pylônes directionnels. Visibilité à distance pour centres commerciaux et zones d'activité." },
  { icon: Blinds, title: "Stores Bannes", desc: "Stores bannes personnalisés avec impression de votre logo et texte. Protection solaire et support de communication." },
  { icon: Store, title: "Habillage Vitrine", desc: "Vitrophanie, adhésif dépoli, covering intégral. Transformez votre vitrine en outil de communication." },
  { icon: Car, title: "Covering Véhicule", desc: "Total covering ou marquage partiel de votre flotte. Transformez chaque déplacement en publicité mobile." },
  { icon: Printer, title: "Impression Grand Format", desc: "Bâches, banderoles, panneaux, roll-up, kakémonos. Impression numérique HD grand format pour tous supports." },
];

export function ServicesSection({ onScrollToForm }) {
  return (
    <section className="py-24 sm:py-32 px-4 sm:px-6 lg:px-8 bg-[#050505]" id="services" data-testid="services-section">
      <div className="max-w-7xl mx-auto">
        {/* Section header like Paclim */}
        <div className="mb-16">
          <p className="text-sm uppercase tracking-[0.3em] font-medium text-[#00FF66] mb-4 font-['Outfit',sans-serif]">NOS SERVICES</p>
          <h2 className="font-['Clash_Display',sans-serif] text-3xl sm:text-4xl font-bold tracking-tight text-white uppercase">
            Une installation adaptée à chaque commerce
          </h2>
        </div>

        {/* Cards grid - Paclim style: dark cards with icon circle + arrow CTA */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {services.map((service, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ delay: idx * 0.06, duration: 0.5 }}
              className="group bg-[#0a0a0a] border border-[#1a1a1a] rounded-none p-7 flex flex-col hover:border-[#00FF66]/30 hover:shadow-[0_0_30px_rgba(0,255,102,0.06)] transition-all duration-500"
              data-testid={`service-${idx}`}
            >
              {/* Icon in circle like Paclim */}
              <div className="w-16 h-16 rounded-full border-2 border-[#00FF66]/40 flex items-center justify-center mb-6 group-hover:border-[#00FF66] group-hover:shadow-[0_0_15px_rgba(0,255,102,0.2)] transition-all duration-300">
                <service.icon className="w-7 h-7 text-[#00FF66]" />
              </div>

              <h3 className="text-white font-bold text-base uppercase tracking-wide font-['Outfit',sans-serif] mb-3">
                {service.title}
              </h3>
              <p className="text-zinc-500 text-sm leading-relaxed mb-6 flex-1">{service.desc}</p>

              {/* Arrow CTA like Paclim */}
              <button
                onClick={onScrollToForm}
                className="inline-flex items-center gap-2 text-sm font-bold text-white uppercase tracking-wider underline underline-offset-4 decoration-[#00FF66] hover:text-[#00FF66] transition-colors group/btn"
                data-testid={`service-cta-${idx}`}
              >
                Devis gratuit
                <ArrowRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
